import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const CardBlock = styled.div`
  padding: 9px 0;

  ${minMediaQueries.phone`
    padding: 9px;
  `};
`;
